<template>
   <div>
    <b-sidebar style="background-color: red" id="sidebar-menu" backdrop backdrop-variant="dark" 
    aria-labelledby="sidebar-menu-title" no-header shadow>
      <template #default="{ hide }">
        <div class="p-3">
        <div class="d-flex align-items-center flex-column mb-3">
        <b-navbar-brand href="#"
        ><img
          src="../../../src/assets/images/dropsmart-logo.png"
          alt="Dropsmart Logo"
          /></b-navbar-brand>
        </div>
          <nav class="mb-3">
            <b-nav vertical>
              <b-nav-item active @click="hide">App</b-nav-item>
              <b-nav-item href="#" @click="hide">Perks</b-nav-item>
              <b-nav-item href="#" @click="hide">Academy</b-nav-item>
              <b-nav-item href="#" @click="hide">Premium</b-nav-item>
              <b-nav-item href="#" @click="hide">Free</b-nav-item>

              <div class="divider-menu"></div>

              <b-nav-item href="#" @click="hide">My account details</b-nav-item>
              <b-nav-item href="#" @click="hide">My basket</b-nav-item>

              <div class="divider-menu"></div>

              <b-nav-item href="#" @click="hide">Upgrade</b-nav-item>
              <b-nav-item href="#" @click="hide">Become a partner</b-nav-item>
              <b-nav-item href="#" @click="hide">Refer to become Premium</b-nav-item>
            </b-nav>
          </nav>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: "SideBar",
  //props: ["menuItems"],
  data() {
    return {
      isActive: 0,
    };
  },
};
</script>

<style scoped lang="scss">

img {
  width: 70%;
}

.nav-item > .nav-link {
  color: #838383;

  &:hover {
    color: black;
  }
}

.divider-menu {
  border: 1px solid #838383;
  margin: 1.4rem 1rem;
}

</style>
